import React, { useState, useEffect, useRef } from 'react';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { Messages } from 'primereact/messages';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
import { useAuth } from '../contexts/AuthContext';
import Container from 'react-bootstrap/Container';
import { ScrollTop } from 'primereact/scrolltop';
import {OverlayPanel} from 'primereact/overlaypanel';
import { ProgressBar } from 'primereact/progressbar';
import '../config.js';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import Login from './Login.js';
import AccessState from './AccessState';
import adminCatalogApi from '../api/adminCatalogApi';
import { upload } from '@testing-library/user-event/dist/upload.js';
import { canReadAdminFlagSystemStatus } from '../utils/flagSystemCapability';


const Customers = () => {
  // Load the status page script
  useStatusPageScript();
  
  const [customers, setCustomers] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState();
  const [orderSelectionModel, setOrderSelectionModel] = useState();
  const navigate = useNavigate();
  const { logout, accessContext } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [accessIssue, setAccessIssue] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    code: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    lms: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    appProvider: { value: null, matchMode: FilterMatchMode.STARTS_WITH }
  });
  const [orderFilters, setOrderFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    orderNumber: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    customer: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    status: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    created: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });
  const [orderDetailsFilters, setOrderDetailsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    locationName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    gateName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    clientName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    type: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    scanType: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    size: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    colour: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const [orderFilterValue, setOrderFilterValue] = useState('');
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [orderDetailsFilterValue, setOrderDetailsFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [loadingOrderDetails, setLoadingOrderDetails] = useState(false);
  const [createVisible, setCreateVisible] = useState(false);
  const msgs = useRef(null);
  const uploadOrdermsg = useRef(null);
  const editOrdermsg = useRef(null);
  const uploadLinksmsg = useRef(null);
  const downloadOrdermsg = useRef(null);
  const editOrderDetailsmsg = useRef(null);
  const replacementLinkMsg = useRef(null);
  const [newCustomerName, setNewCustomerName] = useState('');
  const [newCustomerCode, setNewCustomerCode] = useState('');
  const toast = useRef(null);
  const toastBC = useRef(null);
  const dt = useRef(null);
  const [uploadCSV, setUploadCSV] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [orders, setOrders] = useState([]);
  const [orderVisible, setOrderVisible] = useState(false);
  const [orderDetailsVisible, setOrderDetailsVisible] = useState(false);
  const [orderAccessPoints, setOrderAccessPoints] = useState([]);
  const [orderAccessPointsVisible, setOrderAccessPointsVisible] = useState(false);
  const [innovatiseLinks, setInnovatiseLinks] = useState('');
  const [uploadLinksVisible, setUploadLinksVisible] = useState(false);
  const [ponumber, setPonumber] = useState('');
  const [boostAddress, setBoostAddress] = useState('AW');
  const [customerAddress, setCustomerAddress] = useState('');
  const [collection, setCollection] = useState(false);
  const [isProject, setIsProject] = useState(false);
  const [sendUpdaterTile, setSendUpdaterTile] = useState(false);
  const [delivertoA, setDelivertoA] = useState(true);
  const [innovatiseLink, setInnovatiseLink] = useState('');
  const [showInnovatiseLink, setShowInnovatiseLink] = useState(false);
  const [newLink, setNewLink] = useState('');
  const [uploadResetLinkVisible, setUploadResetLinkVisible] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customerId, setCustomerId] = useState(0);
  const [lmsTypes, setLmsTypes] = useState([]);
  const [appProviders, setAppProviders] = useState([]);
  const [integrationsVisible, setIntegrationsVisible] = useState(false);
  const [integrationsSaving, setIntegrationsSaving] = useState(false);
  const [integrationCustomer, setIntegrationCustomer] = useState(null);
  const [selectedLmsTypeId, setSelectedLmsTypeId] = useState(null);
  const [selectedAppProviderId, setSelectedAppProviderId] = useState(null);
  const integrationsMsg = useRef(null);
  const [newCustomerLmsType, setNewCustomerLmsType] = useState('');
  const [newCustomerAppProvider, setNewCustomerAppProvider] = useState('');
  const [lmsTypeNames, setLmsTypeNames] = useState([]);
  const [appProviderNames, setAppProviderNames] = useState([]);
  const [fullOrderDetails, setFullOrderDetails] = useState([]);
  const [chooseOrderStatusToDownload, setChooseOrderStatusToDownload] = useState(false);
  const [orderStatusToDownload, setOrderStatusToDownload] = useState('');
  const [orderStatusOptions, setOrderStatusOptions] = useState([]);
  const [logoProvided, setLogoProvided] = useState('');
  const [addedToAjax, setAddedToAjax] = useState('');
  const [kitSentDate, setKitSentDate] = useState('');
  const [kitSentPlace, setKitSentPlace] = useState('');
  const [installer, setInstaller] = useState('');
  const [projectNotes, setProjectNotes] = useState('');
  const [submitOrder, setSubmitOrder] = useState(true);
  const [emails, setEmails] = useState('');
  const op = useRef(null);

  // Handle authentication errors by showing login modal instead of redirecting
  const handleAuthError = async () => {
    // await logout();
    setShowLoginModal(true);
  };

  const handleSessionExpired = async () => {
    try {
      await logout();
    } catch (_) {
      // ignore
    }

    setAccessIssue({
      title: 'Session Expired',
      message: 'Your session has expired. Please log in again to continue.',
      actionLabel: 'Go To Login',
      actionTo: '/login',
      autoRedirectTo: '/login',
      autoRedirectDelayMs: 2500,
    });
  };

  // Handle successful login from modal
  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    setAccessIssue(null);
    // Optionally refresh data or show success message
    if (toast.current) {
      toast.current.show({severity: 'success', summary: '', detail: 'Login successful! You can continue working.'});
    }
    if(customers.length === 0){
      getCustomers();
    }
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        await handleSessionExpired();
        return;
      }

      getCustomers();
      getLmsTypes();
      getAppProviders();
    };
    
    fetchCustomers();

    //get filters from local storage
    let _filters = JSON.parse(localStorage.getItem('customers-globalFilter'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters.global.value);
    }
  }, []);


  const getCustomers = async () => {
    try {
      setLoading(true);
      setAccessIssue(null);
      setCustomers([]);
      const token = localStorage.getItem('token');
      const response = await axios.get(global.config.url + '/customers', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      setCustomers(response.data);
      setLoading(false);
      getOrders();

    } catch (error) {
      console.error('Error fetching customers:', error);
      if (error.response && error.response.status === 401) {
        setLoading(false);
        await handleSessionExpired();
      }
      else if (error.response && error.response.status === 403) {
        setLoading(false);
        setAccessIssue({
          title: 'Customers Access Denied',
          message: 'You do not have permission to view customers.',
          actionLabel: 'Go To Home',
          actionTo: '/',
          autoRedirectTo: '/',
          autoRedirectDelayMs: 2500,
        });
      }
    }
  };

  const getLmsTypes = async () => {
    try {
      const catalogLmsTypes = await adminCatalogApi.getLmsTypes();
      setLmsTypes(catalogLmsTypes);
      setLmsTypeNames(catalogLmsTypes.map((item) => ({ label: item.name, value: item.name })));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        await handleSessionExpired();
        return;
      }
      throw error;
    }
  };

  const getAppProviders = async () => {
    try {
      const catalogAppProviders = await adminCatalogApi.getAppProviders();
      setAppProviders(catalogAppProviders);
      setAppProviderNames(catalogAppProviders.map((item) => ({ label: `${item.appName} - ${item.company}`, value: item.company })));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        await handleSessionExpired();
        return;
      }
      throw error;
    }
  };

  const openIntegrationsDialog = (customer) => {
    setIntegrationCustomer(customer);
    setSelectedLmsTypeId(customer && customer.lmsTypeId !== undefined ? Number(customer.lmsTypeId) : null);
    setSelectedAppProviderId(customer && customer.appProviderId !== undefined ? Number(customer.appProviderId) : null);
    setIntegrationsVisible(true);
  };

  useEffect(() => {
    const refreshCatalog = () => {
      getLmsTypes();
      getAppProviders();
    };
    window.addEventListener('smarttile:catalog-updated', refreshCatalog);
    return () => window.removeEventListener('smarttile:catalog-updated', refreshCatalog);
  }, []);

  const integrationActionTemplate = (customer) => (
    <Button
      link
      icon="pi pi-pencil"
      onClick={() => openIntegrationsDialog(customer)}
      tooltip="Edit LMS and App Provider"
      tooltipOptions={{ position: 'bottom' }}
    />
  );

  const saveCustomerIntegrations = async () => {
    if (!integrationCustomer || !Number.isFinite(selectedLmsTypeId) || !Number.isFinite(selectedAppProviderId)) return;

    try {
      setIntegrationsSaving(true);
      const token = localStorage.getItem('token');
      await axios.put(
        global.config.url + `/customers/${integrationCustomer.id}/integrations`,
        { lmsTypeId: selectedLmsTypeId, appProviderId: selectedAppProviderId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (integrationsMsg.current) integrationsMsg.current.show({ severity: 'success', summary: '', detail: 'Customer integrations updated.' });
      await getCustomers();
      setIntegrationsVisible(false);
    } catch (error) {
      const responseMessage = error && error.response && error.response.data;
      const detail = typeof responseMessage === 'string' && (responseMessage === 'LMS type not found.' || responseMessage === 'App provider not found.')
        ? responseMessage
        : 'Unable to update customer integrations.';
      if (integrationsMsg.current) integrationsMsg.current.show({ severity: 'error', summary: '', detail, sticky: true });
    } finally {
      setIntegrationsSaving(false);
    }
  };

  const getLocations = () => {
  // Load the status page script
  
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to view its locations'});
    }
    else{
      navigate(`/locations/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const getClients = () => {
  // Load the status page script
  
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a location to view its clients'});
    }
    else{
      navigate(`/clients/Customer/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const getAccessPoints = () => {
  // Load the status page script
  
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to view its access points.'});
    }
    else{
      navigate(`/accesspoints/Customer/${rowSelectionModel.name}/${rowSelectionModel.id}`);
    }
  };

  const getOrders = async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(global.config.url + `/orders/ordersview/0`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setOrders(response.data);
    let orderStatusOpt = [];
    orderStatusOpt.push('All');
    for (let i = 0; i < response.data.length; i++) {
      orderStatusOpt.push(response.data[i].status);
    }
    setOrderStatusOptions([...new Set(orderStatusOpt)]);
    console.log(response.data);
    setLoadingOrders(false);
  };

  const getOrderDetailsbyOrderId = async () => {
    if(orderSelectionModel === undefined || orderSelectionModel.id === 0 || orderSelectionModel.name === null){
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select an order to view its details.'});
      return;
    }
    editOrdermsg.current.show({severity: 'info', summary: '', detail: 'Loading order details, please wait...'});
    setLoadingOrderDetails(true);
    const token = localStorage.getItem('token');
    const response = await axios.get(global.config.url + `/orders/orderdetails/${orderSelectionModel.id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setFullOrderDetails(response.data);
    setLoadingOrderDetails(false);
    console.log(response.data);
    setOrderDetailsVisible(true);
  };



  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const onGlobalFilterChange = (e) => {
      const value = e.target.value;
      let _filters = { ...filters };

      _filters['global'].value = value;

      localStorage.setItem('customers-globalFilter', JSON.stringify(_filters))

      setFilters(_filters);
      setGlobalFilterValue(value);
  };

  const orderFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...orderFilters };

    _filters['global'].value = value;

    localStorage.setItem('customers-orderFilter', JSON.stringify(_filters))

    setOrderFilters(_filters);
    setOrderFilterValue(value);
};

const orderDetailsFilterChange = (e) => {
  const value = e.target.value;
  let _filters = { ...orderDetailsFilters };
  _filters['global'].value = value;
  localStorage.setItem('customers-orderDetailsFilter', JSON.stringify(_filters))
  setOrderDetailsFilters(_filters);
  setOrderDetailsFilterValue(value);
};

  const getAccessPointsByOrder = async () => {
    if(orderSelectionModel === undefined || orderSelectionModel.id === 0 || orderSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an order to view its access points.'});
      return;
    }
    const token = localStorage.getItem('token');
    const response = await axios.get(global.config.url + `/orders/${orderSelectionModel.id}/accesspoints`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setOrderAccessPoints(response.data);
    setOrderAccessPointsVisible(true);
  };

  const copytoclipboard = () => {
  
    let data = [];
    orderAccessPoints.forEach(element => {
      data.push([element.accessPoint.tile, element.accessPoint.gate, element.accessPoint.location.name]);
    });
    
    const spradsheetData = data.map(row => row.join('\t')).join('\n');

    navigator.clipboard.writeText(spradsheetData)
      .then(() => {
        msgs.current.show({ severity: 'success', summary: '', detail: 'Data copied to clipboard' });
      })
      .catch((err) => {
        msgs.current.show({ severity: 'error', summary: '', detail: 'Failed to copy data to clipboard' });
      });
  };

const handleChange = (e) => {
  console.log(e.target.files);
  if(e.target.files){
    setCsvFile(e.target.files[0]);
  }
}

const handleDelivertoAChange = (value) => {
  setDelivertoA(value);
  if(value){
    setBoostAddress('AW');
  }
  else{
    setBoostAddress('');
  }
}

const handleCollectionChange = (value) => {
  setCollection(value);
  if(value){
    setDelivertoA(false);
    setBoostAddress('Collection');
  }
  else{
    setDelivertoA(true);
    setBoostAddress('AW');
  }
}



const uploadCSVModal = (
  <React.Fragment>
    <Messages ref={uploadOrdermsg} />
    <Card>
    <div className="p-field">
    <InputText type="file" accept=".csv" onChange={handleChange} tooltip="Upload a CSV file with the tiles to be created" tooltipOptions={{position:"bottom"}}/>
    </div>
    <div className="p-field mt-3">
      <InputTextarea type = "text" value={ponumber} onChange={(e) => setPonumber(e.target.value)} tooltip="PO Number" tooltipOptions={{position:"bottom"}}
      placeholder='Type Purchase Order number' cols={40} rows={1} autoResize/>
    </div>
    <div className="p-field mt-3 flex align-items-center">
      <InputSwitch inputId='updaterSwitch' label="Send Updater Tile" className='mr-5' checked={sendUpdaterTile} onChange={(e) => setSendUpdaterTile(e.value)} 
      tooltip="Check if the phone updater tile needs to be sent with this order" tooltipOptions={{position:"bottom"}}/> 
      <label htmlFor='updaterSwitch' className='ml-5'>Send Updater Tile</label>
    </div>
    <div className="p-field mt-3 flex align-items-center">
      <InputSwitch inputId='collectionSwitch' label="Collection" className='mr-5' checked={collection} onChange={(e) => handleCollectionChange(e.value)} 
      tooltip="Check if the tiles need to be collected from Boost" tooltipOptions={{position:"bottom"}}/> 
      <label htmlFor='collectionSwitch' className='ml-5'>Collection</label>
    </div>
    {/*Show if collection is false */
      !collection && 
      (    
      <div className="p-field mt-3">
         <InputSwitch inputId='delivertoASwitch' label="Deliver to A" className='mr-5' checked={delivertoA} onChange={(e) => handleDelivertoAChange(e.value)}
         tooltip="Check if the tiles need to be delivered to AW" tooltipOptions={{position:"bottom"}}/>
          <label htmlFor='delivertoASwitch' className='ml-5'>Deliver to AW</label>
      </div>
      )}
      {
      !delivertoA && !collection &&
      (<div className="p-field mt-3">
        <InputTextarea type = "text" value={boostAddress} onChange={(e) => setBoostAddress(e.target.value)} tooltip="Type Boost delivery address" tooltipOptions={{position:"bottom"}}
        placeholder='Type Boost delivery address' cols={40} rows={5} autoResize/>
      </div> 
    )}
    <div className="p-field mt-3">
      <InputTextarea type = "text" value={customerAddress} onChange={(e) => setCustomerAddress(e.target.value)} tooltip="Type customer delivery address" tooltipOptions={{position:"bottom"}}
      placeholder='Type customer delivery address' cols={40} rows={5} autoResize/>
    </div>
    <div className="p-field mt-3">
      <InputTextarea type = "text" value={emails} onChange={(e) => setEmails(e.target.value)} tooltip="Type emails to send order notification to, separated by semicolons or commas" tooltipOptions={{position:"bottom"}}
      placeholder='Type emails to send order notifications, separated by semicolons or commas' cols={40} rows={2} autoResize/>
    </div>
    <div className="p-field mt-3">
      <InputSwitch inputId='isProjectSwitch' label="Is Project" className='mr-5' checked={isProject} onChange={(e) => setIsProject(e.value)} tooltip="Check if the order is a project" tooltipOptions={{position:"bottom"}}/>
      <label htmlFor='isProjectSwitch' className='ml-5'>Create Project</label>
    </div>
    {isProject && (
      <div>
        <div className="p-field mt-3">
          <InputTextarea type = "text" value={logoProvided} onChange={(e) => setLogoProvided(e.target.value)} tooltip="Has logo been provided" tooltipOptions={{position:"bottom"}}
          placeholder='Logo provided' cols={20} rows={1} autoResize/>
          <InputTextarea type = "date" value={kitSentDate} onChange={(e) => setKitSentDate(e.target.value)} tooltip="Kit sent date" tooltipOptions={{position:"bottom"}}
          placeholder='Kit sent date' autoResize cols={20} rows={1} className='ml-3'/>
          <InputTextarea type = "text" value={installer} onChange={(e) => setInstaller(e.target.value)} tooltip="Installer" tooltipOptions={{position:"bottom"}}
          placeholder='Installer' cols={30} rows={1} autoResize className='ml-3'/>
        </div>
        <div className="p-field mt-3 flex">
          <InputTextarea type = "text" value={addedToAjax} onChange={(e) => setAddedToAjax(e.target.value)} tooltip="Has customer been added to Ajax" tooltipOptions={{position:"bottom"}}
          placeholder='Has customer been added to Ajax' cols={20} rows={1} autoResize/>
          <InputTextarea type = "text" value={kitSentPlace} onChange={(e) => setKitSentPlace(e.target.value)} tooltip="Kit sent place" tooltipOptions={{position:"bottom"}}
          placeholder='Kit sent place' autoResize cols={20} rows={1} className='ml-3'/>
          <InputTextarea type = "text" value={projectNotes} onChange={(e) => setProjectNotes(e.target.value)} tooltip="Type project notes" tooltipOptions={{position:"bottom"}}
          placeholder='Type project notes' cols={30} rows={2} autoResize className='ml-3'/>
        </div>
        <div className="p-field mt-3">
          

        </div>
      </div>
    )}

    <Button disabled={!submitOrder} onClick={() => uploadCSVFunc()} label='Submit' icon="pi pi-send" className="p-button-help is-light mt-3" tooltip="submit csv file" tooltipOptions={{position:"bottom"}}/>
    <Messages ref={uploadOrdermsg} />

  </Card>
  </React.Fragment>
);

  const uploadCSVFunc = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to upload CSV'});
      return;
    }
    //Check emails format
    if(emails !== undefined && emails !== ''){
      const emailArray = emails.split(/[,;]/).map(email => email.trim());
      for(let i=0; i<emailArray.length; i++){
        const email = emailArray[i];
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(email !== '' && !emailRegex.test(email)){
          uploadOrdermsg.current.show({severity: 'error', summary: '', detail: `Invalid email format: ${email}`});
          return;
        }
      }
    }
    if(!csvFile){
      uploadOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select a CSV file to upload'});
      return;
    }
    setSubmitOrder(false);
    uploadOrdermsg.current.show({severity: 'info', summary: '', detail: 'Uploading file, please wait...', life: 30000, closeable: false});
    const formData = new FormData();
    formData.append('file', csvFile);
    const token = localStorage.getItem('token');
    const axiosConfig = {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios.post(global.config.url + `/orders/neworder?customerid=${rowSelectionModel.id}`, formData, axiosConfig);
      // setUploadCSV(false);
      if (response.status === 200) {

        let resp = response.data;
        let baddress = boostAddress;
        if(collection){
          baddress = 'Collection';
          console.log('Collection');
        }
        if(delivertoA){
          baddress = 'AW';
          console.log('AW');
          console.log(baddress);
        }
        let axiosConfig2 = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        };
        await axios.post(global.config.url + '/orders/addorderinfo', {
          "PONumber": ponumber,
          "CustomerAddress": customerAddress,
          "BoostAddress": baddress,
          "RefNumber": resp,
          "SendUpdaterTile": sendUpdaterTile,
          "Emails": emails,
        } , axiosConfig2);
        if(isProject){
          uploadOrdermsg.current.clear();
          uploadOrdermsg.current.show({ severity: 'info', summary: '', detail: `Creating project for order ` + resp, life: 30000, closeable: false });
          let project = {
            "OrderNumber": resp,
            "LogoProvided": logoProvided,
            "AddedToAjax": addedToAjax,
            "KitSentDate": kitSentDate,
            "KitSentPlace": kitSentPlace,
            "Installer": installer,
            "Notes": projectNotes,
            "Status": "New",
            "AddedToSocial": "No",
          };
          await axios.post(global.config.url + '/projects', project , axiosConfig2);
          setIsProject(false);
          setLogoProvided('');
          setAddedToAjax('');
          setKitSentDate('');
          setKitSentPlace('');
          setInstaller('');
          setProjectNotes('');
          uploadOrdermsg.current.clear();
        }
        setPonumber('');
        setCustomerAddress('');
        setBoostAddress('AW');
        setCollection(false);
        setDelivertoA(true);
        getOrders();
        setUploadCSV(false);
        setCsvFile(null);
        setSendUpdaterTile(false);
        msgs.current.show({ severity: 'success', summary: '', detail: `Tiles created and reference number is ` + resp });
      } else if(response.status === 400){
        let resp = response.data;
        uploadOrdermsg.current.clear();
        uploadOrdermsg.current.show({ severity: 'error', summary: '', detail: resp });
      } 
      else {
        uploadOrdermsg.current.show({ severity: 'error', summary: '', detail: `Error uploading file, please try again.` });
      }
      setSubmitOrder(true);
    } catch (error) {
      setSubmitOrder(true);
      setCsvFile(null);
      // setUploadCSV(false);
      console.error('Error uploading file:', error);
      if (error.response && error.response.status === 401) {
        // Logout and redirect to login screen
        // await logout();
        // navigate('/login')
        // Show login modal instead of redirecting
        await handleAuthError();
      } else if (error.response && error.response.status === 400) {
        uploadOrdermsg.current.clear();
        console.log(error.response.data);
        let errors = "";
        if(error.response.data.errors.length > 0){
          error.response.data.errors.forEach(err => {
            uploadOrdermsg.current.show({ severity: 'error', summary: '', detail: err, closeable: true, life: 30000 });
          });
          
        }
        else{
          uploadOrdermsg.current.show({ severity: 'error', summary: '', detail: error.response.data });
        }
      } 
      else{
        uploadOrdermsg.current.clear();
        uploadOrdermsg.current.show({ severity: 'error', summary: '', detail:   `Error uploading file, please try again.` });
      }
    }
  };

  const savelinks = (e) => {
    setInnovatiseLinks(e.target.value);
  };

  const parseSpreadsheet = async () => {
    let data = innovatiseLinks;
    if(data === undefined || data === ''){
      uploadLinksmsg.current.show({severity: 'error', summary: '', detail: 'Please paste the Innovatise links to be created'});
      return;
    }
    console.log(data);
    const rows = data.split('\n');
    console.log(rows);
    const parsedData = [];
    const headers = ['tile', 'gate', 'location', 'extra', 'link'];
    for(let i=0; i<rows.length; i++){
      let row = rows[i].split('\t');
      if(row[0] == undefined || row[0] === ''){
        continue;
      }
      console.log(row);
      let rowData = {};
      headers.forEach((header, index) => {
        rowData[header] = row[index];
      });
      // parsedData.push(rowData);
      let token = localStorage.getItem('token');
      let axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };
      try{
      const response = await axios.post(global.config.url + '/accesspoints/linkbytile', rowData, axiosConfig);

        if(response.status === 200){
          setInnovatiseLinks('');
          uploadLinksmsg.current.show({severity: 'success', summary: '', detail: `Links created successfully.`});
        }
        else{
          uploadLinksmsg.current.show({severity: 'error', summary: '', detail: `Error creating links, please try again.`});
        }
      }
      catch(error)  {
        console.error('Error creating links:', error);
        if (error.response && error.response.status === 401) {
          // Logout and redirect to login screen
          // await logout();
          // navigate('/login');
          await handleAuthError();
        }
        else if(error.response && error.response.status === 409){
          uploadLinksmsg.current.show({severity: 'error', summary: '', detail: error.response.data});
        }
        else if(error.response && error.response.status === 400){
          uploadLinksmsg.current.show({severity: 'error', summary: '', detail: 'The links came emtpy, please check the format and try again.'});
        }
        else if(error.response && error.response.status === 404){
          uploadLinksmsg.current.show({severity: 'error', summary: '', detail: 'The tile does not exist, please check the format and try again.'});
        }
        else if(error.response && error.response.status === 500){
          uploadLinksmsg.current.show({severity: 'error', summary: '', detail: 'Error creating links, please try again.'});
        }
      }
    }
  };

  const disableCustomer = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to disable.'});
      return;
    }
    const token = localStorage.getItem('token');
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios.get(global.config.url + `/customers/disable/${rowSelectionModel.id}`, axiosConfig);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: `Customer ${rowSelectionModel.name} successfully disabled.`});
        getCustomers();
      } else {
        msgs.current.show({severity: 'error', summary: '', detail: `Error disabling customer, please try again.`});
      }
    } catch (error) {
      console.error('Error disabling customer:', error);
      if (error.response && error.response.status === 401) {
        // Logout and redirect to login screen
        // await logout();
        // navigate('/login');
        await handleAuthError();
      } else {
        msgs.current.show({severity: 'error', summary: '', detail: `Error disabling customer, please try again.`});
      }
    }
  };

  const startContent = (
    <React.Fragment>
      <div>
          <Button onClick={() => getLocations()} label="Get Locations" icon="pi pi-map-marker" className="ml-3 mb-3" tooltip="Go to the customer's locations list"
          tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => getClients() } label="Get Clients" icon="pi pi-desktop" className="p-button-info mb-3 ml-3" tooltip="Go to the customer's clients list"
          tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => getAccessPoints()} label="Get Access Points" icon="pi pi-qrcode" className="p-button-success ml-3 mb-3" tooltip="Go to the customer's access points list" 
          tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => sendQRCodes()} label="Send QR Codes" icon="pi pi-qrcode" className="p-button-help mb-3 ml-3" tooltip="Send QR codes to the customer's clients"
          tooltipOptions={{position:"bottom"}}/>
        </div>
        <div className=''>
          <Button onClick={() => setUploadCSV(true)} label="Upload CSV" icon="pi pi-upload" className="p-button-warning ml-3 mb-3" tooltip="Upload a CSV file with the tiles to be created"
          tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => setUploadLinksVisible(true)} label="Upload Innovatise Links" icon="pi pi-upload pi-link" className="p-button-secondary mb-3 ml-3" tooltip="Upload a the links to be added to the system"
          tooltipOptions={{position:"bottom"}}/>
          <Button onClick={(e) => getLinks()}  label='Get replacement link' icon="pi pi-link" className="p-button-primary ml-3 mb-3" tooltip="Get Replacement Link" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => sendOrderCsvbyCustomer()} label='Download Order CSV' icon="pi pi-file-export" className="p-button-info ml-3 mb-3" tooltip="Send Order CSV by Customer" tooltipOptions={{position:"bottom"}}/>
        </div>
        <div className=''>
          <Button onClick={() => disableCustomer()} label="Disable Customer" icon="pi pi-ban" className="p-button-danger ml-3 mb-3" tooltip="Disable the selected customer" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => navigate(`/staffmembers/Customer/${rowSelectionModel ? rowSelectionModel.id : 0}`)} label="Get Staff Members" icon="pi pi-id-card" className="p-button-secondary ml-3 mb-3" tooltip="Get staff members for this customer" tooltipOptions={{position:"bottom"}}/>
          <Button onClick={() => navigate(`/admin/customers/${rowSelectionModel ? rowSelectionModel.id : 0}/wallet`)} label="Wallet Passes" icon="pi pi-wallet" className="p-button-help ml-3 mb-3" tooltip="Manage Wallet Passes for the selected customer" tooltipOptions={{position:"bottom"}}/>
          {canReadAdminFlagSystemStatus(accessContext) && <Button onClick={() => navigate(`/admin/customers/${rowSelectionModel.id}/flags`)} label="Flag System" icon="pi pi-flag"
            className="p-button-help ml-3 mb-3" disabled={!rowSelectionModel || !rowSelectionModel.id}
            tooltip="Manage Flag System access for the selected customer" tooltipOptions={{position:"bottom"}}/>}
        </div>
    </React.Fragment>
);

const footerContent = (
  <div>
      <Button label="No" icon="pi pi-times" onClick={() => setCreateVisible(false)} className="p-button-text" />
      <Button label="Yes" icon="pi pi-check" onClick={() => confirmChange()} autoFocus />
  </div>
);

const clear = () => {
  
  toastBC.current.clear();
};

const confirmChange = () => {
  
  if(newCustomerName=== undefined || newCustomerName=== ''){
    toast.current.show({severity: 'error', summary: '', detail: 'Please enter a name for the new customer.'});
    return;
  }
  if(newCustomerCode === undefined || newCustomerCode === ''){
    toast.current.show({severity: 'error', summary: '', detail: 'Please enter a code for the new customer.'});
    return;
  }
  toastBC.current.show({
      severity: 'info',
      sticky: true,
      className: 'border-none',
      content: (
          <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
              <div className="text-center">
                  <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                  <div className="font-bold text-xl my-3">Are you sure?</div>
              </div>
              <div className="flex align-items-center">
                  <Button onClick={(e) => create()} type="button" label="Confirm" className="p-button-success w-6rem" />
                  <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
              </div>
          </div>
      )
  });
};

const sendQRCodes = async () => {
  let token = localStorage.getItem('token');
  let axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };
  try {
    const response = await axios.get(global.config.url + `/customers/qr/${rowSelectionModel.id}`, axiosConfig);
    if(response.status === 200){
      if(response.data === true){
        msgs.current.show({severity: 'success', summary: '', detail: `QR codes sent successfully.`});
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: `Error sending QR codes, check if the links have been submitted and try again.`});
      }
    }
    else{
      msgs.current.show({severity: 'error', summary: '', detail: `Error sending QR codes, please try again.`});
    }
  } catch (error) {
    console.error('Error fetching customers:', error);
    await logout();
    navigate('/login');
  }
};



const create = async () => {
  clear(true);
  const token = localStorage.getItem('token');
  if(newCustomerLmsType === undefined || newCustomerLmsType === ''){
    toast.current.show({severity: 'error', summary: '', detail: 'Please select a LMS type for the new customer.'});
    return;
  }
  if(newCustomerAppProvider === undefined || newCustomerAppProvider === ''){
    toast.current.show({severity: 'error', summary: '', detail: 'Please select an App Provider for the new customer.'});
    return;
  }
  var newCustomer = {
    name: newCustomerName,
    code: newCustomerCode,
    id: 0,
    key: newCustomerLmsType + ":" + newCustomerAppProvider,
  }
  let axiosConfig = {
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
    }
  };
  try {

    const response = await axios.post(global.config.url + '/customers', newCustomer, axiosConfig);
    console.log(response);
    if(response.status === 201){
      msgs.current.show({severity: 'success', summary: '', detail: `Customer ${response.data.name} successfully created.`});
      getCustomers();
      setCreateVisible(false);
      setNewCustomerCode('');
      setNewCustomerCode('');
    }
    else{
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating customer, please try again.'});
    }

  } catch (error) {
    console.error('Error fetching customers:', error);
    if (error.response && error.response.status === 401) {
      // Logout and redirect to login screen
      // await logout();
      // navigate('/login');
      await handleAuthError();
    }
    else if(error.response && error.response.status === 400){
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating customer, please try again.'});
    }
    else if(error.response && error.response.status === 500){
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating customer, please try again.'});
    }
    else if(error.response && error.response.status === 409){
      toast.current.show({severity: 'error', summary: '', detail: error.response.data});
    }
  }

};

const onOrderEditComplete = async (e) => {
  let {newData, index} = e;
  // let lcs = [...orders];
  // lcs[index] = newData;
  // setOrders(lcs);
  let token = localStorage.getItem('token');
  let axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };
  console.log(newData);
  if(newData.emails !== undefined || newData.emails !== ''){
    //Check emails format
    let emails = newData.emails;
    const emailArray = emails.split(/[,;]/).map(email => email.trim());
    for(let i=0; i<emailArray.length; i++){
      const email = emailArray[i];
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(email !== '' && !emailRegex.test(email)){
        editOrdermsg.current.show({severity: 'error', summary: '', detail: `Invalid email format: ${email}`});
        return;
      }
    }
  }
  try {
    const response = await axios.get(global.config.url + `/tileorder/updateemail/${newData.id}/${newData.emails}`, axiosConfig);
    if(response.status === 200){
      editOrdermsg.current.show({severity: 'success', summary: '', detail: `Order email successfully updated.`});
      getOrders();
    }
    else{
      editOrdermsg.current.show({severity: 'error', summary: '', detail: `Error updating order email, please try again.`});
    }
  } catch (error) {
    console.error('Error updating order:', error);
    if (error.response && error.response.status === 401) {
      // Show login modal instead of redirecting
      await handleAuthError();
    }
    else if(error.response && error.response.status === 400){
      console.log(error);
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error updating order email, please try again.'});
    }
    else{
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error updating order email, please try again.'});
    }
  }
};

const showOrders = (value) => {
  setOrderVisible(value);
  if(value){
    setLoadingOrders(true);
    getOrders();
  }
  };
  

  const optionsSelected = (e, rowData) =>{
    op.current.toggle(e);
    setRowSelectionModel(rowData);
  }

  const optionsTemplate = (rowData) => {
    return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  };

  const copyToClipboard = (e) => {
    console.log(e);
    var textField = document.createElement('textarea')
    textField.innerText = e;
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
  }
  
    const createLink = async () => {
      let token = localStorage.getItem('token');
      let axiosConfig = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.post(global.config.url + '/customers/resetlink', {id:0, customerId: customerId, link: newLink}, axiosConfig);
      console.log(response);
      if(response.status === 200){
        setNewLink('');
        msgs.current.show({severity: 'success', summary: '', detail: `Link created successfully.`});
        setUploadResetLinkVisible(false);
      }
       else 
      {
        msgs.current.show({severity: 'error', summary: '', detail: 'Error creating the link, please try again.'});
      }
    }

    const updateLink = async () => {
      const link = innovatiseLink.trim();

      if (!customerId || !link) {
        replacementLinkMsg.current.show({severity: 'error', summary: '', detail: 'Please enter a replacement link.'});
        return;
      }

      try {
        const token = localStorage.getItem('token');
        const response = await axios.put(global.config.url + `/customers/resetlink/${customerId}`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { link: link },
        });

        if (response.status === 200 || response.status === 204) {
          setInnovatiseLink(link);
          replacementLinkMsg.current.show({severity: 'success', summary: '', detail: 'Replacement link updated successfully.'});
        } else {
          replacementLinkMsg.current.show({severity: 'error', summary: '', detail: 'Error updating the replacement link, please try again.'});
        }
      } catch (error) {
        console.error('Error updating replacement link:', error);
        replacementLinkMsg.current.show({severity: 'error', summary: '', detail: 'Error updating the replacement link, please try again.'});
      }
    }
  
  
    const getLinks = async () => {
      if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
        msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to get its replacement link'});
        return;
      }
      setCustomerName(rowSelectionModel.name);
      setCustomerId(rowSelectionModel.id);
      //get innovatise links from api
      let token = localStorage.getItem('token');
      let axiosConfig = {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.get(global.config.url + `/customers/resetlink/${rowSelectionModel.id}`, axiosConfig);
      console.log(response);
      if(response.status === 200){
        setInnovatiseLink(response.data);
        setShowInnovatiseLink(true);
      }
      else if(response.status === 204){
        setUploadResetLinkVisible(true);
        setInnovatiseLink('');
      }
      else{
        toast.current.show({severity: 'error', summary: '', detail: 'Error fetching link, please try again.'});
      }
    }
    

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

      const textEditor = (options) => {
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
      };
      const textareaEditor = (options) => {
        return <InputTextarea type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} rows={5} cols={30}/>;
      };
  const clearFilter = () => {
  
    let _filters = { ...filters };
    _filters['global'].value = null;
    setFilters(_filters);
    setGlobalFilterValue('');
    localStorage.removeItem('customers-globalFilter');
  };

  const sendOrderCsv = async (customerid = 0, orderid = 0) => {

    const token = localStorage.getItem('token');
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      // responseType: 'blob', // Important for downloading files
    };
    try{
    const response = await axios.get(global.config.url + `/orders/getordercsvreport/${customerid}/${orderid}`, axiosConfig)
        console.log(response);
      const byteCharacters = atob(response.data.data); // decode base64
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.data.name); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        return true;
      }
      catch{
        // console.error('Error downloading CSV:', error);
        return false; // Indicate failure
     };
    
  }

  const downloadOrderCsvByStatus = async () => {
    if(orderStatusToDownload === undefined || orderStatusToDownload === ''){
      downloadOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select an order status to download its report.'});
      return;
    }
    setLoading(true);
    downloadOrdermsg.current.show({severity: 'info', summary: '', detail: 'Preparing CSV report, please wait...', closable: false, life: 60000});
    const token = localStorage.getItem('token');
    const axiosConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      console.log('Downloading CSV for order status:', orderStatusToDownload);
      const response = await axios.get(global.config.url + `/orders/sendorderreportbystatus/${orderStatusToDownload}`, axiosConfig);
      const byteCharacters = atob(response.data.data); // decode base64
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.data.name); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        downloadOrdermsg.current.clear();
        downloadOrdermsg.current.show({severity: 'success', summary: '', detail: `CSV downloaded successfully for order status ${orderStatusToDownload}.`});
        setOrderStatusToDownload('');
        setLoading(false);
        return true;
    } catch (error) {
      console.error('Error downloading CSV:', error);
      downloadOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error downloading CSV, please try again.'});
      if (error.response && error.response.status === 401) {
        // Logout and redirect to login screen
        // await logout();
        // navigate('/login');
        await handleAuthError();
      }
      setLoading(false);
      return false; // Indicate failure
    }
    // setLoading(false);
    // return true; // Indicate success
  };

  // const downloadOrderCsvForAll = async () => {
  //   setLoading(true);
  //   msgs.current.show({severity: 'info', summary: '', detail: 'Preparing CSV report, please wait...', closable: false, life: 60000});
  //   const result = await sendOrderCsv();
  //   if(result){
  //     msgs.current.show({severity: 'success', summary: '', detail: 'CSV downloaded successfully.'});
  //   }
  //   else{
  //     msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading CSV, please try again.'});
  //   }    
  //   setLoading(false);
  // }

  const sendOrderCsvbyCustomer = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.name === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to download its order report.'});
      return;
    }
    setLoading(true);

    msgs.current.show({severity: 'info', summary: '', detail: 'Preparing CSV report, please wait...', life: 60000, closable: false});
    // const token = localStorage.getItem('token');
    // const axiosConfig = {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    //   responseType: 'blob', // Important for downloading files
    // };
    // axios.get(global.config.url + `/orders/sendorderreportbycustomer/${rowSelectionModel.id}`, axiosConfig)
    //   .then((response) => {
    //     msgs.current.show({severity: 'success', summary: '', detail: 'CSV sent successfully.'});
    //     setLoading(false);
        
    //   })
    //   .catch((error) => {
    //     console.error('Error downloading CSV:', error);
    //     msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading CSV, please try again.'});
    //     setLoading(false);
    //  });
    const result = await sendOrderCsv(rowSelectionModel.id, 0);
    if(result){
      msgs.current.clear();
      msgs.current.show({severity: 'success', summary: '', detail: `CSV download successfully.`});
    }
    else{
      msgs.current.clear();
      msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading CSV, please try again.'});
    }
    setLoading(false);
  }

  const sendOrderCsvbyOrder = async () => {
    if(orderSelectionModel === undefined || orderSelectionModel.id === 0 || orderSelectionModel.name === null){
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select an order to download its report.'});
      return;
    }
    setLoading(true);
    editOrdermsg.current.show({severity: 'info', summary: '', detail: 'Preparing CSV report, please wait...', life: 60000, closable: false});
    // const token = localStorage.getItem('token');
    // const axiosConfig = {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    //   responseType: 'blob', // Important for downloading files
    // };
    // axios.get(global.config.url + `/orders/sendorderreportbyorder/${orderSelectionModel.id}`, axiosConfig)
    //   .then((response) => {
    //     editOrdermsg.current.show({severity: 'success', summary: '', detail: 'CSV sent successfully.'});
    //     setLoading(false);
        
    //   })
    //   .catch((error) => {
    //     console.error('Error downloading CSV:', error);
    //     editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error downloading CSV, please try again.'});
    //     setLoading(false);
    //  });
   const result = await sendOrderCsv(0, orderSelectionModel.id)
    if(result){
      editOrdermsg.current.clear();
      editOrdermsg.current.show({severity: 'success', summary: '', detail: `CSV downloaded successfully.`});
    }
    else{
      editOrdermsg.current.clear();
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error downloading CSV, please try again.'});
    }
    setLoading(false);
  }

  const sendShippingNotebyOrder = async () => {
    if(orderSelectionModel === undefined || orderSelectionModel.id === 0 || orderSelectionModel.name === null){
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select an order to send the shipping note.'});
      return;
    }
    setLoading(true);
    editOrdermsg.current.show({severity: 'info', summary: '', detail: 'Sending shipping note, please wait...'});
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(global.config.url + `/orders/sendshippingnote/${orderSelectionModel.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if(response.status === 200){
        editOrdermsg.current.show({severity: 'success', summary: '', detail: `Shipping note for order ${orderSelectionModel.orderNumber} sent successfully.`});
        setLoading(false);
      }
      else{
        editOrdermsg.current.show({severity: 'error', summary: '', detail: `Error sending shipping note, please try again.`});
        setLoading(false);
      }
    } catch (error) {
      console.error('Error sending shipping note:', error);
      setLoading(false);
      if (error.response && error.response.status === 401) {
        // Logout and redirect to login screen
        // await logout();
        // navigate('/login');
        await handleAuthError();
      }
      else if(error.response && error.response.status === 400){
        editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error sending shipping note, please try again.'});
      }
      else{
        editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error sending shipping note, please try again.'});
      }
    }
  }

  const markOrderAsComplete = async () => {
    if(orderSelectionModel === undefined || orderSelectionModel.id === 0 || orderSelectionModel.name === null){
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select an order to mark as complete.'});
      return;
    }
    const token = localStorage.getItem('token');
    let resp = window.confirm('Are you sure you want to mark this order as complete? This action cannot be undone.');
    if(resp === false){
      return;
    }
    try {
      const response = await axios.put(global.config.url + `/orders/markorderascompleted/${orderSelectionModel.id}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if(response.status === 204){
        editOrdermsg.current.show({severity: 'success', summary: '', detail: `Order ${orderSelectionModel.orderNumber} marked as complete.`});
        getOrders();
      }
      else{
        editOrdermsg.current.show({severity: 'error', summary: '', detail: `Error marking order as complete, please try again.`});
      }
    } catch (error) {
      console.error('Error marking order as complete:', error);
      if (error.response && error.response.status === 401) {
        // Logout and redirect to login screen
        // await logout();
        // navigate('/login');
        await handleAuthError();
      }
      else if(error.response && error.response.status === 400){
        editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error marking order as complete, please try again.'});
      }
      else{
        editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error marking order as complete, please try again.'});
      }
    }
  }

    const markOrderAsLive = async () => {
    if(orderSelectionModel === undefined || orderSelectionModel.id === 0 || orderSelectionModel.name === null){
      editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Please select an order to mark as live.'});
      return;
    }
    const token = localStorage.getItem('token');
    let resp = window.confirm('Are you sure you want to mark this order as live? This action cannot be undone.');
    if(resp === false){
      return;
    }
    try{
      //check if order has been marked as complete first
      const resp = await axios.get(global.config.url + `/orders/hasorderbeencompleted/${orderSelectionModel.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
      if(resp.status === 200 && resp.data === false){
        let result = window.confirm('Order has not been marked as complete. Do you still want to proceed?');
        if(result === false){
          return;
        }
      }
    }
    catch (error) {
      }

    try {
      const response = await axios.put(global.config.url + `/orders/markorderaslive/${orderSelectionModel.id}`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if(response.status === 204){
        editOrdermsg.current.show({severity: 'success', summary: '', detail: `Order ${orderSelectionModel.orderNumber} marked as live.`});
        getOrders();
      }
      else{
        editOrdermsg.current.show({severity: 'error', summary: '', detail: `Error marking order as live, please try again.`});
      }
    } catch (error) {
      console.error('Error marking order as live:', error);
      if (error.response && error.response.status === 401) {
        // Logout and redirect to login screen
        // await logout();
        // navigate('/login');
        await handleAuthError();
      }
      else if(error.response && error.response.status === 400){
        editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error marking order as live, please try again.'});
      }
      else{
        editOrdermsg.current.show({severity: 'error', summary: '', detail: 'Error marking order as live, please try again.'});
      }
    }
  }

    const downloadQRPost = async()=> {
  const token = localStorage.getItem('token');
  if(innovatiseLink === ''){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please select a customer to download the QR code.'});
    return;
  }
  //   let axiosConfig = {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  //   responseType: 'blob' // Important
  // };
  // console.log(innovatiseLink);
  try {
    axios.post(global.config.url + `/customers/generateqrfromlink`, {link: innovatiseLink}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    })
    .then(response => {
      console.log(response.data);
      const byteCharacters = atob(response.data.qrCode);
      const byteNumbers = Array.from(byteCharacters).map(ch => ch.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'image/png' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', response.data.name); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      msgs.current.show({severity: 'success', summary: '', detail: 'QR code downloaded successfully.'});
    })
    .catch(error => {
      console.error('QR code generation failed:', error);
      msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading QR code, please try again.'});
    });
  }
  catch (error) {
    console.error('Error downloading QR code:', error);
    msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading QR code, please try again.'});
  }
}

const onOrderDetailsEditComplete = (e) => {
  let result = window.confirm('Are you sure you want to save the changes?');
  if(!result){
    return;
  }
  let { newData, index } = e;
  let orderdetails = [...fullOrderDetails];
  orderdetails[index] = newData;
  setFullOrderDetails(orderdetails);
  setLoadingOrders(true);
  let token = localStorage.getItem('token');
  let axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  };
//   for (const key in newData) {
//   if (newData[key] === null) {
//     newData[key] = ""; // Replace null with desired value
//   }
// }
  const response = axios.put(global.config.url + '/orders/updateorderdetails', newData, axiosConfig);
  response.then((res) => {
    if(res.status === 204){
      editOrderDetailsmsg.current.show({severity: 'success', summary: '', detail: `Order details for order ${newData.orderNumber} successfully updated.`});
      getOrderDetailsbyOrderId();
    }
    else{
      editOrderDetailsmsg.current.show({severity: 'error', summary: '', detail: `Error updating order details, please try again.`});
    }
  }).catch((error) => {
    console.error('Error updating order details:', error);
    if (error.response && error.response.status === 401) {
      // Logout and redirect to login screen
      // logout();
      // navigate('/login');
      handleAuthError();
    }
    else if(error.response && error.response.status === 400){
      editOrderDetailsmsg.current.show({severity: 'error', summary: '', detail: 'Error updating order details, please try again.'});
    }
    else{
      editOrderDetailsmsg.current.show({severity: 'error', summary: '', detail: 'Error updating order details, please try again.'});
    }
  });
};
  if (accessIssue) {
    return (
      <AccessState
        title={accessIssue.title}
        message={accessIssue.message}
        actionLabel={accessIssue.actionLabel}
        actionTo={accessIssue.actionTo}
        autoRedirectTo={accessIssue.autoRedirectTo}
        autoRedirectDelayMs={accessIssue.autoRedirectDelayMs}
      />
    );
  }

  return (
      <Container fluid="md" className='justify-content-md-center mt-5'>
        <script src="https://smarttile.statuspage.io/embed/script.js"></script>
        <div className="mt-3" >
        <Container className="flex align-content-center flex-wrap">
          <h4 className='flex mt-2 mb-3 ml-3 mr-3'>Customers</h4>
          <div>
            <span className="p-input-icon-right ml-2 mb-3">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter by name or code" tooltip="Start typing a customer name or code to filter" tooltipOptions={{position: "bottom"}} />
            </span>
            <Button icon="pi pi-times" className="p-button-text mb-3" onClick={() => clearFilter()} disabled={loading} tooltip="Clear filters" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-refresh" className="p-button-text mb-3" onClick={() => getCustomers()} disabled={loading} tooltip="Refresh customers" tooltipOptions={{position: "bottom"}} />

            <Button icon="pi pi-plus" className="p-button-success ml-2 mr-3 mb-3" rounded onClick={() => setCreateVisible(true)} disabled={loading} tooltip="Create new customer" tooltipOptions={{position: "bottom"}} />
            <Button type="button" icon="pi pi-download" className="p-button-secondary mr-3 mb-3" rounded onClick={() => exportCSV(false)} disabled={loading} tooltip="Download Customers list as csv" tooltipOptions={{position: "bottom"}} />
            <Button type="button" icon="pi pi-list" rounded className="p-button-info mb-3 mr-3" onClick={() => showOrders(true)} disabled={loading} tooltip="View orders" tooltipOptions={{position: "bottom"}} />
            <Button type="button" icon="pi pi-file-export" className="p-button-warning mb-3" rounded onClick={() => setChooseOrderStatusToDownload(true)} disabled={loading} tooltip="Download order report CSV" tooltipOptions={{position: "bottom"}} />
            <Button type="button" icon="pi pi-folder-open" className="p-button-help ml-3 mb-3" rounded onClick={() => navigate('/projects')} disabled={loading} tooltip="Show Projects" tooltipOptions={{position: "bottom"}} />
          </div>
          </Container>
        </div>
        <Messages ref={msgs} />
        {loading && progressbar}

        <div className='justify-content-md-center mt-5'>
          <DataTable value={customers} selectionMode={'single'} selection={rowSelectionModel} onSelectionChange={(e) => setRowSelectionModel(e.value)} 
            dataKey="id" tableStyle={{ minWidth: '1rem' }} filters={filters} filterDisplay="menu" 
            globalFilterFields={['name', 'code', 'lms', 'appProvider']} emptyMessage={loading ? "Loading customers..." : "No customers found."} ref={dt} 
            scrollable scrollHeight="80vh">
              <Column field="options" header="" body={optionsTemplate}> </Column>
              <Column field="name" header="Name" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} ></Column>
              <Column field="code" header="Code" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }}></Column>
              <Column field="lms" header="LMS" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }}></Column>
              <Column field="appProvider" header="App Provider" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }}></Column>
                <Column header="Integrations" body={integrationActionTemplate}></Column>
          </DataTable>
          <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel>
          <Dialog visible={showInnovatiseLink} onHide={() => setShowInnovatiseLink(false)} className='justify-content-center'>
          <React.Fragment>
            <div className="p-fluid p-formgrid p-grid">
            <h5 className='ml-2'>Replacement link for {customerName}</h5>
            <Messages ref={replacementLinkMsg} />
            <Container className="flex align-content-center flex-wrap">
                <InputText id="innovatiseLink" className="flex mt-3" value={innovatiseLink} onChange={(e) => setInnovatiseLink(e.target.value)} placeholder="Enter link" />
                <Button className="p-button-primary flex" link icon="pi pi-save" onClick={updateLink} />
                <Button className="p-button-success flex ml-3" link icon="pi pi-copy" onClick={() => copyToClipboard(innovatiseLink)} />
                <Button className="p-button-primary flex ml-3" link icon="pi pi-download" onClick={() => downloadQRPost()} />
              </Container>
              
            </div>
          </React.Fragment>
          </Dialog>
          <Dialog visible={uploadResetLinkVisible} onHide={() => setUploadResetLinkVisible(false)}>
          <React.Fragment>
            <div className="p-fluid p-formgrid p-grid">
              <div className="p-field p-col-12 p-md-12">
                <h4 className='mt-3'>Add replacement link for {customerName}</h4>
                <InputText id="newLink" value={newLink} onChange={(e) => setNewLink(e.target.value)} placeholder="Enter link" />
                
                <Button className="p-button-success mt-5" label="Create" onClick={createLink} />
              </div> 
            </div>
          </React.Fragment>
          </Dialog>
          <Dialog
            header={integrationCustomer ? `Edit Integrations: ${integrationCustomer.name}` : 'Edit Integrations'}
            visible={integrationsVisible}
            onHide={() => !integrationsSaving && setIntegrationsVisible(false)}
            style={{ width: '28rem' }}
            breakpoints={{ '641px': '100vw' }}
            footer={<div><Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setIntegrationsVisible(false)} disabled={integrationsSaving} /><Button label="Save" icon="pi pi-check" className="p-button-success ml-3" onClick={saveCustomerIntegrations} loading={integrationsSaving} disabled={!Number.isFinite(selectedLmsTypeId) || !Number.isFinite(selectedAppProviderId)} /></div>}
          >
            <Messages ref={integrationsMsg} />
            <div className="p-fluid p-formgrid p-grid">
              <div className="p-field p-col-12">
                <label htmlFor="customer-integration-lms">LMS Type</label>
                <Dropdown
                  id="customer-integration-lms"
                  value={selectedLmsTypeId}
                  options={lmsTypes.map((lmsType) => ({ label: lmsType.name, value: Number(lmsType.id) }))}
                  onChange={(event) => setSelectedLmsTypeId(event.value)}
                  placeholder="Select LMS Type"
                />
              </div>
              <div className="p-field p-col-12">
                <label htmlFor="customer-integration-app-provider">App Provider</label>
                <Dropdown
                  id="customer-integration-app-provider"
                  value={selectedAppProviderId}
                  options={appProviders.map((appProvider) => ({ label: [appProvider.company, appProvider.appName].filter(Boolean).join(' - '), value: Number(appProvider.id) }))}
                  onChange={(event) => setSelectedAppProviderId(event.value)}
                  placeholder="Select App Provider"
                />
              </div>
            </div>
          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog header="Create Customer" className='justify-content-center' visible={createVisible} onHide={() => setCreateVisible(false)} 
            style={{ width: 'auto' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} footer={footerContent}>
            <Toast ref={toastBC} position="top-center" />
            <Toast ref={toast} />
            <Container className="flex align-content-center flex-wrap">
            <div className="p-fluid p-formgrid p-grid">
              <div className="p-field p-col-12 p-md-12"></div>
              <label htmlFor="input_name" className=''>Name</label>
                <InputText
                    id="name"
                    name="name"
                    className='mt-2'
                    value={newCustomerName}
                    onChange={(e) => setNewCustomerName(e.target.value)}
                    tooltip="Customer Name"
                    placeholder='Enter customer name'
                />
                
                <label htmlFor="input_code" className='mt-3'>Code</label>
                <InputText
                    id="code"
                    name="code"
                    className='mt-2'
                    value={newCustomerCode}
                    onChange={(e) => setNewCustomerCode(e.target.value)}
                    tooltip="Customer Code, must be unique"
                    placeholder='Enter customer code'
                />
                
                <label htmlFor="lmsType" className='mt-3'>LMS Type</label>
                <Dropdown id="lmsType" name="lmsType" className='mt-2' value={newCustomerLmsType} options={lmsTypeNames} 
                onChange={(e) => setNewCustomerLmsType(e.value)} placeholder="Select LMS Type" tooltip="Select LMS Type"
                />
                <label htmlFor="appProvider" className='mt-3'>App Provider</label>
                <Dropdown id="appProvider" name="appProvider" className='mt-2' value={newCustomerAppProvider} options={appProviderNames} 
                onChange={(e) => setNewCustomerAppProvider(e.value)} placeholder="Select App Provider" tooltip="Select App Provider"
                />
                </div>
            </Container>
          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog className='justify-content-center' visible={uploadCSV} onHide={() => setUploadCSV(false)}>
            <div className="card">
              <Toolbar className='' start={<h4>Upload new order</h4>}/>
             </div>
          {uploadCSVModal}
          </Dialog>
        </div>
        <div className="card flex justify-content-center" >
          {loadingOrderDetails && progressbar}
          {loadingOrders && progressbar}
          <Dialog className='justify-content-center' visible={orderVisible} onHide={() => setOrderVisible(false)} style={{ minWidth: '5rem' }} >    
            {/* <div className="card">
            <Toolbar className='' start={} />
            </div> */}
            <Container className="flex mx-5">

              <React.Fragment>
              <h4 className='mt-3'>Orders</h4>
                <span className="p-input-icon-left mx-3">
                  <i className="pi pi-search" />
                  <InputText value={orderFilterValue} onChange={orderFilterChange} placeholder="Filter by relay, tile, gate or client name" tooltip="Start typing a relay, tile, gate or client name" tooltipOptions={{position: "bottom"}}  />
                </span>     
                <Button icon="pi pi-qrcode" className="p-button-info" rounded onClick={() => getAccessPointsByOrder()} tooltip="Get access points per order" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-info-circle" className="p-button-primary ml-3" rounded onClick={() => getOrderDetailsbyOrderId()} tooltip="Show Order Details" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-file-export" className="p-button-warning ml-3" rounded onClick={() => sendOrderCsvbyOrder()} tooltip="Download order report CSV" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-envelope" className="p-button-secondary ml-3" rounded onClick={() => sendShippingNotebyOrder()} tooltip="Send shipping note" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-check" className="p-button-success ml-3" rounded onClick={() => markOrderAsComplete()} tooltip="Mark order as kit sent" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-verified" className="p-button-warning ml-3" rounded onClick={() => markOrderAsLive()} tooltip="Mark order as live" tooltipOptions={{position: "bottom"}} />
              </React.Fragment> 
            </Container>
          <div className='justify-content-md-center mt-5 mb-5 mx-5' >
              <Messages ref={editOrdermsg} />
              <DataTable value={orders} dataKey="id" showGridlines filters={orderFilters} 
              globalFilterFields={['orderNumber', 'customerName', 'locations', 'status', 'created']} selectionMode='single' 
              selection={orderSelectionModel} onSelectionChange={(e) => setOrderSelectionModel(e.value)}
              editMode='row' onRowEditComplete={onOrderEditComplete}
              emptyMessage={loadingOrders ? "Loading orders..." : "No orders found."} ref={dt} tableStyle={{ minWidth: '5rem' }}
              scrollable scrollHeight="60vh" style={{ maxWidth: '90rem' }}>
                <Column field="orderNumber" header="Order Number" />
                <Column field="customerName" header="Customer" sortable/>
                <Column field="locations" header="Locations" sortable/>
                <Column field ="type" header="Type" sortable/>
                <Column field ="numberOfTiles" header="No of Tiles"/>
                <Column field="status" header="Status" sortable/>
                <Column field="created" header="Created At" sortable />
                <Column field="emails" header="Emails" editor={(options) => textareaEditor(options)}/>
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
              </DataTable>
          </div>
          </Dialog>
        </div>
        <div className="card flex justify-content-center" >
          <Dialog className='justify-content-center' visible={orderDetailsVisible} onHide={() => setOrderDetailsVisible(false)} style={{ minWidth: '5rem' }} >    
            {/* <div className="card">
            <Toolbar className='' start={} />
            </div> */}
            <Container className="flex mx-5">

              <React.Fragment>
              <h4 className='mt-3'>Orders</h4>
                <span className="p-input-icon-left mx-3">
                  <i className="pi pi-search" />
                  <InputText value={orderDetailsFilterValue} onChange={orderDetailsFilterChange} placeholder="Filter by location name, gate name, size or colour" tooltip="Start typing a location name, gate name, size or colour" tooltipOptions={{position: "bottom"}}  />
                </span>     
                {/* <Button icon="pi pi-qrcode" className="p-button-info" rounded onClick={() => getAccessPointsByOrder()} tooltip="Get access points per order" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-file-export" className="p-button-warning ml-3" rounded onClick={() => sendOrderCsvbyOrder()} tooltip="Download order report CSV" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-check" className="p-button-success ml-3" rounded onClick={() => markOrderAsComplete()} tooltip="Mark order as completed" tooltipOptions={{position: "bottom"}} />
                <Button icon="pi pi-envelope" className="p-button-secondary ml-3" rounded onClick={() => sendShippingNotebyOrder()} tooltip="Send shipping note" tooltipOptions={{position: "bottom"}} /> */}
              </React.Fragment> 
            </Container>
          <div className='justify-content-md-center mt-5 mb-5 mx-5' >
              <Messages ref={editOrderDetailsmsg} />
              <DataTable value={fullOrderDetails} dataKey="id" showGridlines filters={orderDetailsFilters} 
              globalFilterFields={['locationName', 'gateName', 'clientName', 'type', 'scanType', 'size', 'colour']} selectionMode='single' 
              emptyMessage={loadingOrders ? "Loading order details..." : "No order details found."} ref={dt} tableStyle={{ minWidth: '5rem' }}
              scrollable scrollHeight="60vh" style={{ maxWidth: '90rem' }}
              editMode='row' onRowEditComplete={onOrderDetailsEditComplete}>
                <Column field="customerName" header="Customer" sortable frozen/>
                <Column field="locationName" header="Location" sortable frozen/>
                <Column field="gateName" header="Gate" sortable frozen/>
                <Column field="orderNumber" header="Order Number" />
                <Column field="orderType" header="Order Type" sortable/>
                <Column field="clientName" header="Client Name" sortable/>
                <Column field ="type" header="Type" sortable/>
                <Column field ="scanType" header="Scan Type" sortable/>
                <Column field ="lms" header="LMS" />
                <Column field ="controllerType" header="Controller Type" sortable editor={(options) => textEditor(options)}/>
                <Column field ="hubNumber" header="Hub Number" editor={(options) => textEditor(options)}/>
                <Column field ="relayNumber" header="Relay Number" editor={(options) => textEditor(options)}/>
                <Column field ="buttonNumber" header="Button Number" editor={(options) => textEditor(options)}/>
                <Column field ="size" header="Size" sortable editor={(options) => textEditor(options)}/>
                <Column field ="colour" header="Colour" sortable editor={(options) => textEditor(options)}/>
                <Column field ="quantity" header="Quantity" editor={(options) => textEditor(options)}/>
                <Column field="scanner" header="Scanner" sortable editor={(options) => textEditor(options)}/>
                <Column field="singleCable" header="Single Cable" editor={(options) => textEditor(options)}/>
                <Column field="doubleCable" header="Double Cable" editor={(options) => textEditor(options)}/>
                <Column field="accessPointSetup" header="AccessPoint Setup" />
                <Column field="deepLinkEntered" header="Deep Link Entered" />
                <Column field="clientInstalled" header="Client Installed"/>
                <Column field="ordered" header="Ordered"/>
                <Column field="boostShipped" header="Boost Shipped"/>
                <Column field="orderSent" header="Kit Sent"/>
                <Column field="live" header="Live"/>
                <Column field="status" header="Status"/>
                <Column field="comments" header="Comments" editor={(options) => textEditor(options)}/>
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
              </DataTable>
          </div>
          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog className='justify-content-center' visible={orderAccessPointsVisible} onHide={() => setOrderAccessPointsVisible(false)}>
          <div className="card">
            <Toolbar className='' start={<h4>Order Access Points</h4>} end={            
              <React.Fragment>
                <Button icon="pi pi-copy" className='p-button-info' rounded onClick={() => copytoclipboard()} tooltip="Copy to clipboard" tooltipOptions={{position: "bottom"}}/>
              </React.Fragment>    
            }/>
            </div>
          <div className='justify-content-md-center mt-5'>
            <React.Fragment>
              <Messages ref={msgs} />
              <DataTable value={orderAccessPoints} dataKey="id" showGridlines selectionMode='single'>
                <Column field="accessPoint.tile" header="Tile"  />
                <Column field="accessPoint.gate" header="Gate"  />
                <Column field="accessPoint.location.name" header="Location"  />
              </DataTable>
            </React.Fragment>
          </div>
          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog className='justify-content-center' visible={uploadLinksVisible} onHide={() => setUploadLinksVisible(false)}>
          <div className="card">
            <Toolbar className='' start={<h4>Upload Innovatise Links</h4>} end={            
              <React.Fragment>
                <Button icon="pi pi-times" className="p-button-text" onClick={() => setUploadLinksVisible(false)} tooltip="Close" tooltipOptions={{position: "bottom"}} />
              </React.Fragment>    
            }/>
            </div>
            <div className='justify-content-md-center mt-5'>
              <Messages ref={uploadLinksmsg} />
              <InputTextarea placeholder='Paste Innovatise info from spreadsheet' type="text" onChange={savelinks} tooltip="Paste Innovatise info from spreadsheet" 
              tooltipOptions={{position:"bottom"}} 
              cols={60} rows={7}/>
            </div> 
              <Button onClick={() => parseSpreadsheet()} label='Submit' icon="pi pi-send" className="p-button-help is-light mt-5" tooltip="submit csv file" tooltipOptions={{position:"bottom"}}/>


          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog className='justify-content-center' visible={chooseOrderStatusToDownload} onHide={() => setChooseOrderStatusToDownload(false)}>
          <div className="card">
            <Toolbar className='' start={<h4>Download Order Report</h4>} end={            
              <React.Fragment>
                <Button icon="pi pi-times" className="p-button-text" onClick={() => setChooseOrderStatusToDownload(false)} tooltip="Close" tooltipOptions={{position: "bottom"}} />
              </React.Fragment>    
            }/>
            </div>
              <div className='justify-content-md-center mt-5'>
                <Messages ref={downloadOrdermsg} />
                
                <Dropdown id="orderStatus" name="orderStatus" className='mt-2' value={orderStatusToDownload} options={orderStatusOptions} 
                onChange={(e) => setOrderStatusToDownload(e.value)} placeholder="Select Order Status" tooltip="Select Order Status"
                />
              </div>
              <Button label='Download' icon='pi pi-download' className='p-button-success mt-5' onClick={() => downloadOrderCsvByStatus()} />
          </Dialog>
          </div>

        {/* Login Modal */}
        <div className="card flex justify-content-center">
        <Dialog 
          header="Session Expired - Please Login Again" 
          visible={showLoginModal} 
          style={{ width: '450px' }} 
          modal={true}
          closable={false}
          className="justify-content-center"
        >
            <p className="mb-3">Your session has expired. Please log in again to continue working without losing your form data.</p>
          <div className="flex justify-content-center">
            <Login onLoginSuccess={handleLoginSuccess} />
          </div>
        </Dialog>
        </div>

        <ScrollTop />
      </Container>
  );
};

export default Customers;
